export default "__VITE_ASSET__BZYor8nh__"